export const APPID = window.wxappid
